import { Object3D, Vector3 } from 'three';

/**
 *  Enum values for the dxf unit
 */
export enum DxfUnit {
  Unitless = 0,
  Inches = 1,
  Feet = 2,
  Miles = 3,
  Millimeters = 4,
  Centimeters = 5,
  Meters = 6,
  Kilometers = 7,
  Microinches = 8,
  Mils = 9,
  Yards = 10,
  Angstroms = 11,
  Nanometers = 12,
  Microns = 13,
  Decimeters = 14,
  Decameters = 15,
  Hectometers = 16,
  Gigameters = 17,
  Astronomicalunits = 18,
  Lightyears = 19,
  Parsecs = 20,
  Unknown = 21,
}

/**
 *  Swedish names of the DxfUnits
 */
export const getDxfUnitName = (dxfUnit: DxfUnit): string => {
  switch (dxfUnit) {
    case DxfUnit.Unitless:
      return 'Enhetslös';
    case DxfUnit.Inches:
      return 'Tum';
    case DxfUnit.Feet:
      return 'Fot';
    case DxfUnit.Miles:
      return 'Mile';
    case DxfUnit.Millimeters:
      return 'Millimeter';
    case DxfUnit.Centimeters:
      return 'Centimeter';
    case DxfUnit.Meters:
      return 'Meter';
    case DxfUnit.Kilometers:
      return 'Kilometer';
    case DxfUnit.Microinches:
      return 'Microtum';
    case DxfUnit.Mils:
      return 'Mil';
    case DxfUnit.Yards:
      return 'Yard';
    case DxfUnit.Angstroms:
      return 'Angström';
    case DxfUnit.Nanometers:
      return 'Nanometer';
    case DxfUnit.Microns:
      return 'Mikro';
    case DxfUnit.Decimeters:
      return 'Decimeter';
    case DxfUnit.Decameters:
      return 'Decameter';
    case DxfUnit.Hectometers:
      return 'Hectometer';
    case DxfUnit.Gigameters:
      return 'Gigameter';
    case DxfUnit.Astronomicalunits:
      return 'Astronomisk';
    case DxfUnit.Lightyears:
      return 'Ljusår';
    case DxfUnit.Parsecs:
      return 'Parsec';
    case DxfUnit.Unknown:
    default:
      return '-';
  }
};

interface ThreeDxfLayer {
  [key: string]: { geometry: Object3D; texts: any[] };
}

export interface ThreeDxfData {
  units: DxfUnit;
  extents: { min: Vector3; max: Vector3 };
  layers: ThreeDxfLayer;
  containsSurface: boolean;
  contains3dPolyline: boolean;
}
